import { DEFAULT_LEGAL_COUNTRY_LANGUAGE } from 'util/config/constant';
import immutable from 'immutable';
import { UPDATE_LEGAL_COUNTRY_LANGUAGE } from './action';

const init = () => {
  const initValue = immutable.fromJS({
    languageCode: DEFAULT_LEGAL_COUNTRY_LANGUAGE
  });

  return initValue;
};

export default function legalReducer(state = init(), action) {
  switch (action.type) {
    case UPDATE_LEGAL_COUNTRY_LANGUAGE: {
      const {
        payload: { languageCode }
      } = action;

      return state.update('languageCode', () => languageCode);
    }

    default:
      return state;
  }
}
